import React, { useMemo } from "react";
import FilterPanel from "../../../../components/filters/FilterPanel";
import { ArticleTag, useGetArticleTagsQuery } from "../../../../__generated__/api";
import Styles from "./ArticleTags.module.scss";
import Dropdown from "../../../../components/theme/dropdown/Dropdown";
import Icon from "../../../../components/theme/icon/Icon";
import Text from "../../../../components/theme/text/Text";
import { Filters } from "../../../../components/filters/Filters";
import { Property } from "../../../../components/dirty-tracker/FormTracker";

export default function ArticleTagPicker({
    tags,
}: {
    tags: Property<Partial<ArticleTag>[]>
}) {
    const { data, loading } = useGetArticleTagsQuery();

    const options = data?.articleTags.map(tag => ({
        value: tag.id,
        label: tag.title,
    }));

    const tagsMap = useMemo(() => data?.articleTags.toIdMap("id"), [data]);

    return (
        <Dropdown placement="bottom-start">
            <Dropdown.Toggle
                prefixIcon={
                    <Icon.Add />
                }
                className={Styles["article-tag-picker-toggle"]}
                variant="none"
                size="xsmall"
            >
                Add Categories
            </Dropdown.Toggle>
            <Dropdown.Menu className={Styles["article-tag-picker"]}>
                <Text className={Styles["article-tag-picker-text"]} textVariant="body-2-regular" colorVariant="body-secondary">
                    This article will appear under each selected category in the left sidebar.
                </Text>
                <FilterPanel
                    isMulti
                    className={Styles["article-tag-picker-filter"]}
                    itemClassName={Styles["article-tag-picker-item"]}
                    searchMinimum={3}
                    categories={options}
                    searchMaximum={20}
                    searchPlaceholder="Search categories..."
                    selectedCategories={new Set(tags.value.toIdList("id"))}
                    onSelected={current => {
                        tags.setValue(Array.from(current).mapFilter(id => tagsMap?.[id]));
                    }}
                />
            </Dropdown.Menu>
        </Dropdown>

    );
}
